<div class="container-canjes">
    <h2 style="text-align: center;">Canjes</h2>
    <div *ngIf="canjes">

        <p-table [value]="paginacionCanjesSupervisores" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">Fecha Solicitud</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">status</th>
                    <th scope="col">No Casos Clinicos</th>
                    <th scope="col">Fecha Respuesta</th>
                    <th scope="col">Acciones</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-canje>
                <tr>
                    <td>{{canje.fechaInicio | date: "dd/MM/yyyy"}}</td>
                    <td>{{canje.redimir}}</td>
                    <td><span
                            [ngClass]="{'solicitud': canje.status === 1,'rechazado': canje.status === 2, 'procesado': canje.status === 3, 'cancelado': canje.status === 4}">
                            {{getDescripcion(canje.status)}}
                        </span>
                    </td>
                    <td>{{canje.casosclinicos.length}}</td>
                    <td>{{canje.fechaFinal | date: "dd/MM/yyyy"}}</td>
                    <td>
                        <a *ngIf="(canje.status === 3 || canje.status === 2 || canje.status === 4)"
                            [routerLink]="['/supervisor/canje/detalle', canje.id]"><i class="pi pi-eye"
                                style="color: slateblue"></i></a>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center p-4">
                        <div class="flex flex-column align-items-center">
                            <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                            <span class="text-600 mt-2">No se encontraron canjes</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <div class="card flex justify-content-center">
            <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage.first" [rows]="currentPage.rows"
                [totalRecords]="totalItems"></p-paginator>
        </div>

    </div>

</div>